import React, { Component } from 'react';
import XLSX from 'xlsx';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import _ from 'lodash';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';

import { updateQuestionsBatch } from '../../../services/apiService';
import { questionValidationText } from './../constants';
import { UPLOAD_BULK_QUES_TEMPLATE_URL } from '../../../aws-exports';

class UploadCSV extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fileRef: 0,
      file: '',
      sheetData: [],
      formattedData: [],
      validatedData: [],
      buttonDisplay: true,
      insertedRecord: -1,
      totalRecord: -1,
      validationError: 'all',
    };
  }

  componentDidMount = () => {
    this.setState({ fileRef: React.createRef() });
  };

  getRatingTemplateIdByName = (templateName) => {
    const allRatingTemplates = this.props.ratingTemplates;
    const selectedTemplate = allRatingTemplates?.find(
      (elem) => elem.title.toUpperCase() === templateName.toUpperCase()
    );
    return selectedTemplate?.id || '';
  };

  getSubTopicIds = (subtopicNames) => {
    // subtopicName to subtopicId mapping obj
    const subtopicMapping = {};
    this.props.subTopics.forEach(({ id, name }) => {
      subtopicMapping[name] = id;
    });
    return subtopicNames.map((name) => subtopicMapping[name]);
  };

   utf8Decode(utf8String) {
    if (typeof utf8String !== 'string') throw new TypeError('parameter ‘utf8String’ is not a string');
    const unicodeString = utf8String.replace(
        /[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,  
        function(c) {  
            const cc = ((c.charCodeAt(0)&0x0f)<<12) | ((c.charCodeAt(1)&0x3f)<<6) | ( c.charCodeAt(2)&0x3f);
            return String.fromCharCode(cc); }
    ).replace(
        /[\u00c0-\u00df][\u0080-\u00bf]/g,                 
        function(c) {  
            const cc = (c.charCodeAt(0)&0x1f)<<6 | c.charCodeAt(1)&0x3f;
            return String.fromCharCode(cc); }
    );
    return unicodeString;
}

  handleFile = (file) => {
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array' });
      // Get first worksheet
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      // Convert array of arrays
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      // Updating state
      this.setState({ sheetData: data }, () => this.formatData());
    };
    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  };

  validateSheet = () => {
    const sheetData = this.state.sheetData;
    if (this.state.file === '') {
      alert('Please select a file first');
      return false;
    }
    if (sheetData?.[0]?.length < 9) {
      alert('Data Not Valid');
      return false;
    }
    return true;
  };

  validateObjData = (obj) => {
    const errors = [];
    // Checking if Question is not null
    if (!obj?.question) errors.push(questionValidationText.QUESTION_NULL);

    //  Checking if Solution is not null
    if (!obj?.solution) errors.push(questionValidationText.SOLUTION_NULL);

    // Checking if Competency is null
    if (!obj?.concept) errors.push(questionValidationText.CONCEPT_NULL);

    // Checking if Competency is valid
    if (!obj?.conceptId) errors.push(questionValidationText.CONCEPT_INVALID);

    // Checking if difficulty level is valid
    if (!['easy', 'medium', 'hard'].includes(obj?.difficultyLevel))
      errors.push(questionValidationText.DIFFICULTY_INVALID);

    // Checking if Question Image Url is valid
    if (obj?.questionImageUrl && !obj.questionImageUrl.startsWith('http'))
      errors.push(questionValidationText.QUESTION_IMG_INVALID);

    // Checking if Question Image Url is valid
    if (obj?.solutionImageUrl && !obj.solutionImageUrl.startsWith('http'))
      errors.push(questionValidationText.QUESTION_IMG_INVALID);

    return errors;
  };

  formatData = () => {
    const array = this.state.sheetData;
    this.validateSheet();
    const formattedData = [];
    const validatedData = [];
    let validRecord = 0;
    let total = 0;
    for (let index = 1; index < array.length; index++) {
      const element = array[index];
      const conceptId = this.props.conceptIdFromConceptName[element[8]];
      total = total + 1;

      // Creating Object From data array
      let obj = {
        identifier: element[0],
        question: this.utf8Decode(element[1]),
        questionImageUrl: element[2],
        solution: element[3],
        solutionImageUrl: element[4],
        difficultyLevel: element[5]?.toLowerCase(),
        module: element[6],
        competency: element[7],
        concept: element[8],
        conceptId,
        // companyTags: this.stringToArray(element[8]),
        // positionTags: this.stringToArray(element[9]),
      };
      formattedData.push({ ...obj });

      // VALIDATION CHECK
      const validationErrors = this.validateObjData(obj); // return empty array if no errors
      if (validationErrors?.length === 0) {
        validRecord = validRecord + 1; // Keeping counter of records having no validation error
      }
      obj = { ...obj, validationErrors: [...(validationErrors || [])] };
      validatedData.push(obj);
    }
    this.setState({
      validatedData: validatedData,
      insertedRecord: validRecord,
      totalRecord: total,
      formattedData: [...formattedData],
    });
  };

  // Function to Add All question to the Database
  uploadingAllQuestions = async () => {
    if (!this.validateSheet()) {
      return;
    }

    if (this.state.totalRecord === -1) {
      alert('Please Validate Sheet Data');
      return;
    }
    this.setState({ buttonDisplay: false });
    const allData = [...this.state.formattedData];
    for (let i = 0; i < allData.length; i++) {
      delete allData[i].identifier; // Deleting identifier key from object
      delete allData[i].module; // Deleting module key from object
      delete allData[i].competency; // Deleting competency key from object
      delete allData[i].concept; // Deleting concept key from object
    }
    let resp;
    try {
      resp = await updateQuestionsBatch(allData);
    } catch (err) {
      alert('Some Error Occurred');
      console.error(err);
      this.setState({ buttonDisplay: true });
      return false;
    }
    if (resp) {
      alert(`${this.state.totalRecord} Questions Added Successfully`);
      this.setState({ buttonDisplay: true });
    } else {
      alert('Data update Failed');
    }
  };

  validationFilterDisplay = (data) => {
    if (this.state.validationError === 'all') {
      return true;
    } else if (
      this.state.validationError === 'error' &&
      data.validationErrors.length !== 0
    ) {
      return true;
    }
    return false;
  };

  render() {
    return (
      <div>
        <div
          className='bg-white center p-11 border-b border-solid border-gray-400'
          onDragLeave={() => {
            this.setState({ file: 1 });
          }}
        >
          <center>
            <i className='my-3 fas fa-file-upload text-5xl text-gray-500' />
            <br />
            <span className='my-2 text-gray-500 text-xl font-semibold'>
              Drag and Drop files here
            </span>
            <br />
            <span className='my-2 text-gray-500'>
              Supported Files: CSV, XLSX
            </span>
            <br />
            <button
              onClick={() => this.state?.fileRef?.current?.click()}
              className='font-semibold my-3 bg-gray-300 px-5 py-2 rounded'
            >
              Choose File
            </button>
            <a
              href={UPLOAD_BULK_QUES_TEMPLATE_URL}
              target='_blank'
              rel='noreferrer'
              download
            >
              <button className='my-3 mx-3 bg-blue-300 px-3 py-2 rounded font-semibold'>
                Download Template
              </button>
            </a>
            <br />
            <span className='my-3 text-gray-500'> Maximize File Size 8 MB</span>
            <br />
            <input
              onChange={(e) => this.setState({ file: e.target.files })}
              type='file'
              ref={this.state.fileRef}
              hidden={true}
              accept='.csv, .xlsx'
            />
            <br />
            {this.state.file !== '' ? (
              <h1 className='text-lg font-medium text-green-500'>
                File Added: <b>{this.state.file?.[0]?.name}</b>
              </h1>
            ) : (
              <h1> </h1>
            )}
            <br />
            {this.state.file !== '' && !this.state.sheetData.length ? (
              <button
                onClick={() => this.handleFile(this.state?.file?.[0])}
                className='block mb-3 bg-blue-500 px-5 rounded py-2 text-white mt-6'
              >
                Analyse Data
              </button>
            ) : (
              ''
            )}
            {this.state.totalRecord !== -1 && (
              <>
                {this.state.totalRecord === this.state.insertedRecord ? (
                  <div>
                    {this.state.buttonDisplay ? (
                      <button
                        onClick={this.uploadingAllQuestions}
                        className='rounded bg-green-600 px-8 py-3 text-white font-semibold'
                      >
                        Add All Questions
                      </button>
                    ) : (
                      <span className='font-semibold text-blue-400'>
                        Processing. Please Wait...
                      </span>
                    )}
                  </div>
                ) : (
                  <span className='text-red-500 font-semibold text-lg'>
                    Validation Errors Found !
                  </span>
                )}
              </>
            )}
          </center>
        </div>

        {this.state?.formattedData?.length !== 0 && (
          <div className='bg-white '>
            <div className='items-center flex justify-between card-header p-5 border-b-2 border-gray-500 shadown'>
              <h1 className='text-xl font-semibold text-gray-400'>
                Analysed Data From Sheet
              </h1>
              <select
                onChange={(e) =>
                  this.setState({ validationError: e.target.value })
                }
                className='border border-gray-300 px-8 py-2 text-lg'
                value={this.state?.validationFilter}
              >
                <option value='all'>All</option>
                <option value='error'>Error</option>
              </select>
            </div>
            <div
              className='card-body overflow-scroll'
              style={{ height: '30rem' }}
            >
              <table className='p-5'>
                <thead>
                  <tr>
                    <th className='border border-gray-500 p-3 bg-blue-200'>
                      Identifier
                    </th>
                    <th className='border border-gray-500 p-3 bg-blue-200'>
                      Question
                    </th>
                    <th className='border border-gray-500 p-3 bg-blue-200'>
                      Question Image
                    </th>
                    <th className='border border-gray-500 p-3 bg-blue-200'>
                      Answer
                    </th>
                    <th className='border border-gray-500 p-3 bg-blue-200'>
                      Answer Image
                    </th>
                    <th className='border border-gray-500 p-3 bg-blue-200'>
                      Difficulty Level
                    </th>
                    <th className='w-1/2 border border-gray-500 p-3 bg-blue-200'>
                      Module (L1)
                    </th>
                    <th className='w-1/2 border border-gray-500 p-3 bg-blue-200'>
                      Competencty (L2)
                    </th>
                    <th className='w-1/2 border border-gray-500 p-3 bg-blue-200'>
                      Concept (L3)
                    </th>
                    {/* <th className='border border-gray-500 p-3 bg-blue-200'>
                      Company Tags
                    </th>
                    <th className='border border-gray-500 p-3 bg-blue-200'>
                      Position Tags
                    </th> */}
                    <th className='border border-gray-500 p-3 bg-blue-200 whitespace-nowrap'>
                      Validation
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.validatedData?.map((row, index) => (
                    <React.Fragment key={index}>
                      {this.validationFilterDisplay(row) && (
                        <tr
                          key={index}
                          className={
                            row?.validationErrors?.length > 0
                              ? 'bg-red-100'
                              : 'bg-white'
                          }
                        >
                          <td className='border border-gray-500 p-3'>
                            {row?.identifier || index}
                          </td>
                          <td
                            data-tip={row?.question}
                            className=' max-w-lg border border-gray-500 p-3'
                          >
                                {row?.question}
                          </td>
                          <td
                            data-tip={row?.questionImageUrl}
                            className='truncate max-w-sm border border-gray-500 p-3'
                          >
                            {row?.questionImageUrl}
                          </td>
                          <td
                            data-tip={row?.solution}
                            className='whitespace-nowrap truncate max-w-lg border border-gray-500 p-3'
                          >
                            <pre>
                              <code>
                                {row?.solution}
                              </code>
                            </pre>
                          </td>
                          <td
                            data-tip={row?.solutionImageUrl}
                            className='truncate max-w-sm border border-gray-500 p-3'
                          >
                                {row?.solutionImageUrl}
                          </td>
                          <td className='border border-gray-500 p-3'>
                            {row?.difficultyLevel}
                          </td>
                          <td className='whitespace-nowrap border border-gray-500 p-3'>
                            {row?.module}
                          </td>
                          <td className='whitespace-nowrap border border-gray-500 p-3'>
                            {row?.competency}
                          </td>
                          <td className='whitespace-nowrap border border-gray-500 p-3'>
                            {row?.concept} <br /> ({row.conceptId})
                          </td>
                          {/* <td className='border border-gray-500 p-3'>
                            {row?.companyTags}
                          </td>
                          <td className='border border-gray-500 p-3'>
                            {row?.positionTags}
                          </td> */}
                          <td className='border border-gray-500 p-3 whitespace-nowrap text-green-c2'>
                            {row?.validationErrors?.length === 0 ? (
                              <CheckCircleIcon />
                            ) : (
                              <span className='text-red-c1'>
                                {row.validationErrors.toString()}
                              </span>
                            )}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
              <ReactTooltip className='max-w-3xl' />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ questionLevelsReducer }) => ({
  conceptIdFromConceptName: _.fromPairs(
    questionLevelsReducer.concepts.map((cpt) => [cpt.name, cpt.id])
  ),
});

export default connect(mapStateToProps)(UploadCSV);
